import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { selectActiveFirmId, setActiveFirmId } from "redux/slices/client";
import TextSelect from "./TextSelect";
import { SxProps, Theme } from "@mui/material";
import { useFirmsByLensId } from "helpers/hooks/useAllowedLenses";

interface TextSelectFirmsProps {
  sx?: SxProps<Theme>;
  lensId?: number;
}

const TextSelectFirms = (props: TextSelectFirmsProps) => {
  const { sx, lensId } = props;
  const firms = useFirmsByLensId(lensId);

  const activeFirmId = useAppSelector(selectActiveFirmId);
  const dispatch = useAppDispatch();
  const optionFirms = [{ label: "All Firms", value: "" }].concat(
    firms.map((f) => ({ label: f.name, value: `${f.id}` }))
  );

  useEffect(() => {
    // if the lens changes, reset the active firm
    dispatch(setActiveFirmId(""));
  }, [lensId]);

  const onFirmChange = (event) => {
    const firmId = event.target.value;

    if (firmId) {
      dispatch(setActiveFirmId(firmId));
    } else {
      dispatch(setActiveFirmId(""));
    }
  };

  return <TextSelect sx={sx} onChange={onFirmChange} options={optionFirms} value={`${activeFirmId}`} />;
};

export default TextSelectFirms;
